// B3.7 — opt-in discovery offer (per-mode tour config).

import { markFireflyDiscoveryOfferDismissed } from "@/lib/firefly/fireflyTourDiscoveryStorage";

export type FireflyDiscoveryTourOfferProps = {
  tourId: string;
  title: string;
  body: string;
  visible: boolean;
  onAccept: () => void;
  onDismiss: () => void;
};

export function FireflyDiscoveryTourOffer({
  tourId,
  title,
  body,
  visible,
  onAccept,
  onDismiss,
}: FireflyDiscoveryTourOfferProps) {
  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Firefly tour offer"
      className="fixed bottom-24 right-4 z-[9145] w-[min(18rem,calc(100vw-2rem))] rounded-xl border border-blue-400/50 bg-white p-3 shadow-lg dark:border-blue-500/35 dark:bg-zinc-900"
    >
      <p className="text-xs font-semibold text-blue-800 dark:text-blue-200">{title}</p>
      <p className="mt-1 text-[11px] text-gray-600 dark:text-zinc-400">{body}</p>
      <div className="mt-2 flex justify-end gap-2">
        <button
          type="button"
          className="rounded-lg px-2 py-1 text-[11px] font-medium text-gray-600 hover:text-gray-900 dark:text-zinc-400"
          onClick={() => {
            markFireflyDiscoveryOfferDismissed(tourId);
            onDismiss();
          }}
        >
          Not now
        </button>
        <button
          type="button"
          className="rounded-lg bg-blue-600 px-2.5 py-1 text-[11px] font-semibold text-white hover:bg-blue-700"
          onClick={onAccept}
        >
          Show me
        </button>
      </div>
    </div>
  );
}
